import React from 'react';
import { withStyles } from '@material-ui/core/styles';

// MaterialUI Components
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
// Custom Components
import SystemFieldSelect from 'admin/components/RoleMapper/SystemFieldSelect';
// Utilities
import isDocCollectSystemField from 'common/utilities/isDocCollectSystemField';
import * as FieldTypes from 'common/utilities/constants/fieldTypes';

const styles = {
  drawerText: {
    fontWeight: 600,
  },
};

const PrepopulateSection = props => {
  const {
    classes = {},
    tags = [],
    fieldValues = {},
    selectSystemField,
    handleOpenMenu,
    updateField,
    disabled: upstreamDisabled = false,
    multiLevelMenuProps = {},
  } = props;

  const { textType, customProperties = {}, systemField = {} } = fieldValues;
  const { collectSystemField = false } = customProperties || {};
  const isW4OrW9 = tags.some(tag => isDocCollectSystemField(tag.name));
  const isSystemField = systemField.label && systemField.label !== 'None';
  const isDisabled =
    textType === FieldTypes.SIGNATURE.toLowerCase() ||
    textType === FieldTypes.INITIAL_SIGNATURE.toLowerCase();
  const menuIcon = systemField.name ? <CloseIcon /> : <SearchIcon />;
  const iconAction = systemField.name
    ? () => selectSystemField({ label: 'None', name: '' })
    : handleOpenMenu;
  return (
    <React.Fragment>
      <SystemFieldSelect
        onClick={iconAction}
        disabled={isDisabled || upstreamDisabled}
        menuIcon={menuIcon}
        multiLevelMenuProps={multiLevelMenuProps}
        systemField={systemField}
      />
      <div>
        <Typography className={classes.drawerText}>
          Collect System Field Data from User Input:
        </Typography>
        <FormControlLabel
          key="collect-system-field-checkbox"
          control={
            <Checkbox
              checked={collectSystemField}
              onChange={() =>
                updateField(
                  !collectSystemField,
                  'customProperties',
                  'collectSystemField',
                )
              }
              disabled={isW4OrW9 || !isSystemField || upstreamDisabled}
              data-test-id="FieldDrawer-collectCheckbox"
            />
          }
          label="Collect from user"
        />
      </div>
    </React.Fragment>
  );
};

export default withStyles(styles)(PrepopulateSection);
